<app-detail-template>
    <div container-header>
        <app-internal-pends-detail-header></app-internal-pends-detail-header>
    </div>
    <div container-body>
        <router-outlet></router-outlet>
    </div>
</app-detail-template>